import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient";
import { ResponseData } from "../types/_public";
import { IRankifyKeyword } from "../types/newshub/_rankify";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_rankify_keywords = PATH_NEWSHUB_API + '/rankify-keywords';

const rankifyApi = {
  keywords(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<IRankifyKeyword[]>, any>> {
    const url = `${path_rankify_keywords}`;
    return api.get(url, params);
  },
  allCategories(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<any[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/categories`;
    return api.get(url, params);
  },
}
export default rankifyApi
